// src/pages/History/EarlyModern/EuropeanMaritimeEmpiresGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Early_Modern_Period_-_European_Maritime_Empires.png';

function HistoryPageEuropeanMaritimeEmpiresGo() {
  return (
    <QuizPage
      title="History: European Maritime Empires"
      subTopic="European Maritime Empires"
      backgroundImage={historyImage}
      returnPath="/History-European-Maritime-Empires"
    />
  );
}

export default HistoryPageEuropeanMaritimeEmpiresGo;
